module.exports = {
    EDUCATION: 1,
    EMPLOYER: 2,
};



//////////////////
// WEBPACK FOOTER
// ./src/constants/site-modes.js
// module id = 32
// module chunks = 58